module.exports = __webpack_public_path__ + "img/43200.87c2c8f7.jpg";